/**
 * Waits for a certain time before resolving a promise
 */
export const wait = async (miliseconds, value = undefined) => {
    return new Promise((resolve) => {
        setTimeout(() => resolve(value), miliseconds);
    });
};
const backoffDefaults = { waitTime: 0.1, maxAttempts: 7 };
/**
 * Decorator function, will retry the provided function, untill either
 * it returns a promise that resolves or it stops at `maxAttempts` and
 * throws original error
 */
export const backoff = (fn, { waitTime, maxAttempts } = backoffDefaults) => {
    return async (...args) => {
        let attempts = 0;
        while (attempts < maxAttempts) {
            try {
                await wait(waitTime * 1000);
                return await fn(...args);
            }
            catch (error) {
                attempts += 1;
                waitTime *= 2;
                // eslint-disable-next-line no-console
                console.warn(`Retry attempt ${attempts}`);
            }
        }
        return fn(...args);
    };
};
/**
 * Promisify existing callback function
 * Have to define a wrapper function to handle runtime errors.
 *
 *
 * @example
 * promisify(() => opr.privateApi)
 */
// type Callback<P, Q> = (error: P, response: Q) => void;
export const promisify = (f) => (...args) => new Promise((res, rej) => {
    const callback = (response) => {
        if (chrome?.runtime?.lastError) {
            rej(chrome.runtime.lastError);
            return;
        }
        res(response);
    };
    f()(...args, callback);
});
